<template>
  <div class="downloadCom">
    <div class="list">
      <div class="item" v-for="item in downloadData" :key="item.id">
        <div class="itemInner">
          <div class="itemContent">
            <img class="itemBg" :src="item.image" alt="" />
            <div
              class="clickDownload"
              :class="{ downloading: item.downloading }"
              @click="triggerDownload(item);"
            >
              <div class="clickDownloadInner">
                <i v-show="!item.downloading" class="fa fa-download"></i>
                <span>{{ item.downloading ? item.dlstatus : "下载" }}</span>
              </div>
            </div>
            <div class="itemTime" @click="triggerDownload(item);">
              {{ item.duration }}
            </div>
            <div v-if="item.downloading" class="itemProgress">
              <el-progress
                type="circle"
                :status="item.dlstatus"
                :percentage="item.percentage"
                :width="progressObject.width"
                :stroke-width="progressObject.stroke_width"
                :color="progressObject.color"
              />
            </div>
          </div>
          <div class="itemInformation">
            <div class="itemTitle">{{ item.episode }}</div>
            <div class="itemDescription">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'downloadCom',
  props: ['downloadData'],
  data () {
    return {
      progressObject: {
        width: 100,
        stroke_width: 5,
        color: '#3bc0d0'
      }
    }
  },
  created () {},
  methods: {
    triggerDownload (item) {
      this.$emit('triggerDownload', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.downloadCom {
  .list {
    zoom: 1;
    &:after {
      content: "020";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .item {
      float: left;
      width: 20%;
      cursor: pointer;
      .itemInner {
        margin: 8px;
        .itemContent {
          position: relative;
          .itemBg {
            width: 100%;
            min-height: 120px;
          }
          .clickDownload {
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            .clickDownloadInner {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              color: #fff;
            }
          }
          &:hover .clickDownload {
            opacity: 1;
            transition: 0.4s 0.4s opacity ease;
          }
          .downloading {
            opacity: 1;
          }
          .itemTime {
            position: absolute;
            bottom: 10px;
            right: 10px;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            padding: 4px 8px;
            font-size: 12px;
            border-radius: 20px;
          }
          .itemProgress {
            position: absolute;
            top: calc(50% - 50px);
            left: calc(50% - 50px);
          }
        }
        .itemInformation {
          .itemTitle {
            font-size: 16px;
            margin-bottom: 8px;
          }
          .itemDescription {
            font-size: 14px;
            height: 20px;
            color: #888;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
